import './Gallery.scss';
ComponentManager.init(document.body);